module.exports = __webpack_public_path__ + "img/vipevent_regional_icon@2x.9c11630e.png";